import { render, staticRenderFns } from "./CollectiveBrand.vue?vue&type=template&id=b2c0c94e&scoped=true"
import script from "./CollectiveBrand.vue?vue&type=script&lang=js"
export * from "./CollectiveBrand.vue?vue&type=script&lang=js"
import style0 from "./CollectiveBrand.vue?vue&type=style&index=0&id=b2c0c94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c0c94e",
  null
  
)

export default component.exports